jQuery(document).ready(function ($) {
    $(".search-icon").click(function (e) {
        e.preventDefault();
        $(".search-bar").toggleClass('expanded');
        $(".search-icon .icon").toggleClass('rotate'); // Add the class to the <i> element
        if ($(".search-bar").hasClass('expanded')) {
            $(".search-field").focus();
        } else {
            if ($(".search-field").val().trim() !== '') {
                $(".search-form").submit();
            }
        }
        e.stopPropagation();
    });

    $(document).click(function (event) {
        if (!$(event.target).closest(".search-bar").length && !$(event.target).hasClass("search-icon")) {
            $(".search-bar").removeClass("expanded");
            $(".search-icon .icon").removeClass('rotate');
        }
    });
});
